import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Form, Select, Typography } from "antd";
import styled from "styled-components";

import { SEC_FONT_GREY } from "../../constant/colors";
import { selectUnits } from "../../store/selector";
import { optionsSearch } from "../../utils/search";

const { Text } = Typography;
const { Option } = Select;

const FormItemStyled = styled(Form.Item)`
  .ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional) {
    &::before {
      display: none;
    }
    &::after {
      display: inline-block;
      margin-right: 4px;
      line-height: 1;
      content: "*";
      color: ${SEC_FONT_GREY};
    }
  }
`;

const UnitFormItemComponent = ({
  t,
  style,
  label,
  units,
  required = true,
  editable = true,
  showLabel = false,
  strong = false,
  dataTMId,
  name = "dosageUnit",
  recordInfo
}) => (
  <FormItemStyled
    name={recordInfo ? [recordInfo.key, recordInfo.dataIndex] : name}
    rules={[{ required, message: t("form.unit.error_required") }]}
    label={showLabel ? <Text strong={strong}>{label ? label : t("form.unit.label")}</Text> : null}
    colon={false}
    style={style}
  >
    <Select
      disabled={!editable}
      placeholder={t("new_patient.unit_placeholder")}
      showSearch={true}
      filterOption={optionsSearch}
      data-tm-id={dataTMId}
    >
      {units.map((unit, index) => (
        <Option key={index} value={unit}>
          {unit}
        </Option>
      ))}
    </Select>
  </FormItemStyled>
);

const mapStateToProps = createStructuredSelector({
  units: selectUnits
});

const UnitFormItem = connect(mapStateToProps)(withTranslation()(UnitFormItemComponent));

export { UnitFormItem };
